import React from 'react';
import { Link } from 'react-router-dom';
import { t } from '../../../../../i18n';
import { ArrowLeftIconComponent } from '../../../../assets';
import './styles.scss';

const BackButton = ({ to }) => {
  return (
    <Link to={to} className="courses-watch-lesson__back-button">
      <ArrowLeftIconComponent />
      <span>{t('DIGITAL_COURSES.WATCH.BACK_TO_COURSE_PREVIEW')}</span>
    </Link>
  );
};

export default BackButton;
